'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Switch } from 'react-router-dom';
import AuthRedirection from '../containers/AuthRedirection';
import StagingAuthRedirection from '../containers/StagingAuthRedirection';
import JwtAuthRedirection from '../containers/JwtAuthRedirection';
import StagingJwtAuthRedirection from '../containers/StagingJwtAuthRedirection';
export default function Routes() {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/authenticate",
      exact: true,
      component: AuthRedirection
    }), /*#__PURE__*/_jsx(Route, {
      path: "/staging/authenticate",
      exact: true,
      component: StagingAuthRedirection
    }), /*#__PURE__*/_jsx(Route, {
      path: "/jwt/authenticate",
      exact: true,
      component: JwtAuthRedirection
    }), /*#__PURE__*/_jsx(Route, {
      path: "/staging/jwt/authenticate",
      exact: true,
      component: StagingJwtAuthRedirection
    })]
  });
}